// extracted by mini-css-extract-plugin
module.exports = {"list":"Tabs_list__1PIew","item":"Tabs_item__1FVtw","selected":"Tabs_selected__1evEU"};